import { Dropdown, IDropdownOption } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import styles from './LanguageSelector.module.css';

const LanguageSelector = () => {
    const { i18n } = useTranslation();

    const languageOptions: IDropdownOption[] = [
        { key: 'en', text: 'English' },
        { key: 'nl', text: 'Nederlands' }
    ];

    const onChange = (event: React.FormEvent<HTMLDivElement>, item?: IDropdownOption): void => {
        if (item) {
            i18n.changeLanguage(item.key as string);
        }
    };

    return (
        <div className={styles.languageSwitcherContainer}>
            <Dropdown
                placeholder="Select a language"
                options={languageOptions}
                selectedKey={i18n.language}
                onChange={onChange}
                styles={{ dropdown: { width: 150 } }}
            />
        </div>
    );
};

export default LanguageSelector; 